export default {
  LABEL_TITLE_DEFAULT: {
    en: 'Preorder Now | Faraday Future',
    zh: '无畏前行 | Faraday Future'
  },
  LABEL_DESCRIPTION_DEFAULT: {
    en: "Become one of world's first group of owners of FF 91 2.0 Futurist and join the movement to cocreate the future of mobility.",
    zh: '我们致力于 打造更加互联、 直观、轻松的 现代生活 - Faraday Future'
  },
  LABEL_SAVE_CONFIGURATION: {
    en: 'Save Configuration',
    zh: '保存您的配置'
  },
  LABEL_EDIT_CONFIGURATION: {
    en: 'Edit Configuration',
    zh: '编辑您的配置'
  },
  LABEL_PAINT: {
    en: 'Paint',
    zh: '外观颜色'
  },
  LABEL_INTERIOR: {
    en: 'Interior',
    zh: '内饰'
  },
  LABEL_FEATURES: {
    en: 'Features',
    zh: '特性'
  },
  LABEL_VIEW: {
    en: 'View',
    zh: '视角'
  },
  LABEL_VIEW_DRIVER: {
    en: 'Front',
    zh: '前排'
  },
  LABEL_VIEW_PASSENGER: {
    en: 'Rear',
    zh: '后排'
  },
  LABEL_START: {
    en: 'Start',
    zh: '开始'
  },
  LABEL_CONFIGURE: {
    en: 'Configure',
    zh: '配置'
  },
  LABEL_PRICE: {
    en: 'Price',
    zh: '价格'
  },
  LABEL_EXPECTED_TO_BE_AVAILABLE: {
    en: 'Expected to be available ',
    zh: '预计发售时间'
  },
  LABEL_CHOOSE_YOUR_MODEL: {
    en: 'Choose your model to get started.',
    zh: '选择车型开始配置'
  },
  LABEL_BACK: {
    en: 'Back',
    zh: '上一步'
  },
  LABEL_NEXT: {
    en: 'Next',
    zh: '下一步'
  },
  LABEL_SELECT: {
    en: 'Select',
    zh: '选择'
  },
  LABEL_SEAT_OPTIONS: {
    en: 'Seat Options',
    zh: '座位配置'
  },
  LABEL_EXTERIOR: {
    en: 'Exterior',
    zh: '外观'
  },
  LABEL_SUMMARY: {
    en: 'Summary',
    zh: '您的配置'
  },
  LABEL_NAV_YOUR_SUMMARY: {
    en: 'Your Summary',
    zh: '您的配置'
  },
  LABEL_WHEELS: {
    en: 'Wheels',
    zh: '轮毂'
  },
  LABEL_FIRST_NAME: {
    en: 'First Name',
    zh: '名'
  },
  LABEL_LAST_NAME: {
    en: 'Last Name',
    zh: '姓'
  },
  LABEL_LOGIN_DESCRIPTION: {
    en: 'An account is required for saving your configuration.',
    zh: '需要创建账号来保存您的配置.'
  },
  LABEL_LOGIN_DESCRIPTION_ORDER: {
    en: 'An account is required for placing your order.',
    zh: '需要创建账号来提交您的订单.'
  },
  LABEL_LOGIN_OR_REGISTER: {
    en: 'Log In / Register',
    zh: '登录 / 注册'
  },
  LABEL_MOBILE_NUMBER: {
    en: 'Mobile Number',
    zh: '手机号码'
  },
  LABEL_EMAIL_ADDRESS: {
    en: 'Email Address',
    zh: '邮箱地址'
  },
  LABEL_ACCOUNT_EXISTS: {
    en: 'An account is associated with this email.',
    zh: '该邮箱已经注册.'
  },
  LABEL_LOG_IN: {
    en: 'Log In',
    zh: '登录'
  },
  LABEL_TO_CONTINUE: {
    en: 'to continue.',
    zh: '继续.'
  },
  LABEL_CONTINUE_TO_ORDER: {
    en: 'Continue to order',
    zh: '继续订购'
  },
  LABEL_PASSWORD: {
    en: 'Password',
    zh: '密码'
  },
  LABEL_CONFIRM_PASSWORD: {
    en: 'Confirm Password',
    zh: '确认密码'
  },
  LABEL_EDIT: {
    en: 'Edit',
    zh: '修改'
  },
  LABEL_CLOSE: {
    en: 'Close',
    zh: '关闭'
  },
  LABEL_MODEL: {
    en: 'Model',
    zh: '车型'
  },
  LABEL_NAV_SUMMARY: {
    en: 'Summary',
    zh: '汇总'
  },
  LABEL_CONFIRMATION_SUCCESS: {
    en: 'Thank you for saving your design.',
    zh: '您的配置已经保存成功.'
  },
  LABEL_DESIGN_CONFIRMATION: {
    en: 'Design Confirmation',
    zh: '配置确认'
  },
  LABEL_MY_DESIGN_DESCRIPTION: {
    en: 'To view the full details of your design, visit your "My Designs"',
    zh: '更多关于您的设计选项, 请访问APP中 "我的设计"'
  },
  LABEL_VIEW_MY_DESIGN: {
    en: 'View My Designs',
    zh: '查看我的设计'
  },
  LABEL_RESERVATION: {
    en: 'Preorder',
    zh: '预订'
  },
  LABEL_YOUR_CONFIGURATION: {
    en: 'Your Configuration',
    zh: '您的配置'
  },
  LABEL_DESIGN_YOURS: {
    en: 'Design Yours',
    zh: '定制FF 91'
  },
  LABEL_TIP_USE_LANDSCAPE: {
    en: 'Rotate screen to landscape for a better experience',
    zh: '将您手机的屏幕旋转为横向以获得更好的观看体验'
  },
  LABEL_SUMMARY_FEE_DISCLAIMER: {
    en: 'Not include sales tax, delivery fee, registration fee, DMV fee etc.',
    zh: ''
  },
  LABEL_SUMMARY_REPLACEMENT_DISCLAIMER: {
    en: 'Original reservation with Futurist will be replaced by Alliance',
    zh: ''
  },
  LABEL_AGREE_TO_AGREEMENT: {
    en: 'By placing this order, I agree to the',
    zh: ''
  },
  LABEL_ORDER_AGREEEMENT: {
    en: 'Order Agreement',
    zh: '订购协议'
  },
  LABEL_FF: {
    en: 'FF',
    zh: 'FF'
  },
  LABEL_SUBTOTAL: {
    en: 'Subtotal',
    zh: '小计'
  },
  LABEL_DEPOSIT_AMOUNT: {
    en: 'Deposit Amount',
    zh: '存款金额'
  },
  TOOLTIP_DEPOSIT_AMOUNT: {
    en: 'Required deposit amount to place an order for your FF 91.',
    zh: '要求存款金额为您的FF 91下订单。'
  },
  LABEL_NON_REFUNDABLE: {
    en: 'Non-refundable',
    zh: '不可退款'
  },
  LABEL_PURCHASE_PRICE: {
    en: 'Purchase Price',
    zh: '购买价格'
  },
  LABEL_PLACE_ORDER: {
    en: 'Place Order',
    zh: '下订单'
  },
  LABEL_PREORDER_CREDIT_APPLIED: {
    en: 'Preorder Credit Applied',
    zh: '已使用预订信用'
  },
  TOOLTIP_PREORDER_CREDIT_APPLIED: {
    en: 'Credit applied from your initial preorder deposit. Credit will be reflected under Billing in My FF and applied to the purchase of your FF 91.',
    zh: '从初始预订存款中适用的信用。信用将在我的FF中的帐单中反映，并应用于购买FF 91。'
  },
  LABEL_DUE_TODAY: {
    en: 'Due Today',
    zh: '今天需支付金额'
  },
  LABEL_ACCOUNT_BALANCE: {
    en: 'Account Balance',
    zh: '账户余额'
  },
  TOOLTIP_ACCOUNT_BALANCE: {
    en: 'Credits in Account Balance will be applied to the purchase of your FF 91.',
    zh: '帐户余额中的积分将应用于购买FF 91。'
  },
  LABEL_NON_REFUNDABLE_ORDER_FEE: {
    en: 'Non-refundable Order Fee',
    zh: '不可退订单费用'
  },
  LABEL_RESERVATION_BALANCE: {
    en: 'Preorder Balance',
    zh: '预订余额'
  },
  LABEL_GO_TO_MY_VEHICLE_COLLECTION: {
    en: 'Go to My Vehicle Collection',
    zh: ''
  },
  LABEL_GO_TO_MY_DESIGN: {
    en: 'Go to My Design',
    zh: ''
  },
  LABEL_CONFIGURATION_SAVED: {
    en: 'Successfully saved',
    zh: ''
  },
  LABEL_PRICE_INCLUDED: {
    en: 'Included',
    zh: ''
  },
  LABEL_PREORDER_WELCOME: {
    en: "To start production or change your order you must confirm your car's model and configuration. Please select to continue",
    zh: ''
  },
  LABEL_PREORDER_DOWNGRADE_BUTTON: {
    en: 'Order Instead',
    zh: ''
  },
  LABEL_WELCOME_BACK: {
    en: 'Welcome back',
    zh: ''
  },
  LABEL_SAVED_CONFIGURATION_MESSAGE: {
    en: 'Would you like to continue your current configuration or start over?',
    zh: ''
  },
  LABEL_START_OVER: {
    en: 'Start Over',
    zh: ''
  },
  LABEL_CONTINUE: {
    en: 'Continue',
    zh: ''
  },
  LABEL_EXTERIOR_RESTRICTION_TOOLTIP: {
    en: 'Limited interior options available.'
  },
  LABEL_INTERIOR_RESTRICTION_TOOLTIP: {
    en: 'interior not available with'
  },
  LABEL_INVALID_PREORDER: {
    en: 'The preorder applied on your configuration is not valid. Please start over.'
  }
};
